export default __webpack_public_path__ + "static/media/KimberlyClarkLogo.eeafbfc3.svg";